module.exports = __webpack_public_path__ + "static/media/nmc.62bee51e.svg";